import { render, staticRenderFns } from "./pro_link.vue?vue&type=template&id=09f56800&scoped=true&"
import script from "./pro_link.vue?vue&type=script&lang=js&"
export * from "./pro_link.vue?vue&type=script&lang=js&"
import style0 from "./pro_link.vue?vue&type=style&index=0&id=09f56800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f56800",
  null
  
)

export default component.exports